export default {
  hi_im_neela: 'Ciao, sono Neela,',
  english: 'Inglese',
  german: 'Deutsch',
  french: 'Français',
  dutch: 'Nederlands',
  swedish: 'Svenska',
  ukrainian: 'Українці',
  turkish: 'Türkçe',
  russian: 'russian',
  spanish: 'Español',
  italian: 'Italiano',
  arabic: 'عربي',
  polish: 'Polska',
  aareons_virtual: 'Assistente virtuale di Aareon',
  media: 'Media',
  media_link: 'https://neela.aareon.com/media',
  contact: 'Contatto',
  contact_link: 'https://neela.aareon.com/contact',
  privacy: 'Privacy',
  privacy_link: 'https://www.aareon.com/sixcms/detail.php/3627',
  terms_of_use: "Condizioni d'uso",
  terms_of_use_link: 'https://www.aareon.com/sixcms/detail.php/3621',
  legal_notice: 'Avviso legale',
  legal_notice_link: 'https://neela.aareon.com/legal',
  show_system_messages: 'Mostra i messaggi di sistema',
  dont_show_system_messages: 'Nascondi i messaggi di sistema',
  logged_in: "L'inquilino è autenticato",
  logged_out: 'Utente anonimo',
  button_switch_locale: 'Cambia lingua',
  button_tooltip_activate_voice_recognition: 'Attiva il riconoscimento vocale',
  date_input: 'Selezioni la data',
  choose_two_dates: 'Selezioni due date',
  date_range: 'Intervallo di date',
  from: 'da',
  to: 'a',
  avatar: 'Avatar',
  exit: 'Uscita',
  new: 'Nuovo',
  back: 'Indietro',
  suggestions: 'Suggerimenti',
  senton: 'Inviato su',
  message_placeholder: 'Inserisca qui il messaggio',
  comment_placeholder: 'Inserisca qui il suo commento',
  file_max_upload_text: 'È possibile caricare un massimo di 20 file',
  message_button_label: 'Invia',
  please_confirm: 'Confermi',
  no: 'No',
  yes: 'Sì',
  modal_delete_session: 'Elimina sessione',
  modal_delete_session_notification:
    'Se chiude la finestra, anche la sua sessione sarà cancellata.<br>Le va bene?',
  template_contact_time: 'Quando possiamo contattarla?',
  template_pause:
    "La sua sessione è stata messa in pausa. Uno dei nostri addetti all'assistenza si occuperà a breve della sua richiesta.",
  template_continue_after_pause:
    'La sua sessione è continuata. Ora può continuare a scrivere con il nostro chatbot',
  button_apply: 'Applica',
  button_cancel: 'Annulla',
  none: 'Nessuno',
  book_appointment: 'Prenota appuntamento',
  address_input: 'Inserimento indirizzo',
  data_processing: 'Elaborazione dati',
  privacy_policy: 'Informativa sulla privacy',
  data_processing_notification_before_link:
    'Per utilizzare questo servizio di chat è necessario che accetti la ',
  data_processing_notification_after_link: '.',
  button_accept: 'Accetta',
  select_date: 'Seleziona data',
  rate_conversation: 'Come valuterebbe questa conversazione?',
  new_ticket_question: "C'è qualcos'altro che posso fare per aiutarla?",
  thank_you:
    'Grazie per il suo supporto. Il suo feedback mi aiuta a migliorarmi costantemente',
  goodbye: 'Arrivederci',
  start_new: 'Inizia una nuova conversazione',
  operator_entered_the_chat: "L'operatore è entrato nella chat",
  operator_left_the_chat: "L'operatore ha lasciato la chat",
  bg_image: process.env.VUE_APP_EN_BG,
  expand_quickreplies: 'Altro',
  collapse_quickreplies: 'Meno',
  login: 'Accedi',
  logout: 'Esci',
  close: 'Chiudi',
  upload_file: 'Lasci i file ovunque per caricarli',
  upload_file_or: 'o',
  Upload_file_select: 'Aggiungi file',
  upload_file_text: 'Lasciare i file da caricare',
  show_attachments: 'Mostra allegati',
  hide_attachments: 'Nascondi allegato',
  maximize: 'Massimizza',
  minimize: 'Riduci al minimo',
  feedback_helpful: 'Questa risposta mi ha aiutato',
  feedback_not_helpful: 'Questa risposta non mi ha aiutato',
  chatProtocol: 'ChatProtocol',
  showMore: 'Mostra di più',
  showLess: 'Mostra meno',
  uploadTooltip: 'Carica file',
  uploadFilesTooltip: 'Carica file',
  pdfDownloadTooltip: 'Scarica la conversazione',
  feedbackDescription: 'Feedback',
  feedbackSubtitle: {
    description:
      'Qui può inviarci suggerimenti, proposte e richieste di carattere generale',
    note: 'La preghiamo di notare che non possiamo rispondere',
    hint:
      'Tutte le altre preoccupazioni che riguardano specificamente la sua locazione o la ricerca di un appartamento possono esserci descritte nella chat.'
  },
  feedbackPlaceholder: 'Inserisca qui il suo messaggio...',
  sendFeedback: 'Invia',
  giveFeedback: 'Feedback',
  feedbackSubmittedSuccessfully: 'Il suo feedback è stato inviato con successo',
  thanks: 'Grazie'
}
